import { Link, useHistory } from 'react-router-dom';
import React, { useEffect, useState } from 'react'
import CheckoutProduct from './CheckoutProduct';
import './Payment.css';
import { useStateValue } from './StateProvider';
import { CardElement, useElements, useStripe } from '@stripe/react-stripe-js';
import CurrencyFormat from 'react-currency-format';
import { getBasketTotal } from './reducer';
import axios from './axios';
import { db } from './firebase';

function Payment() {
    const [{ basket, user }, dispatch] = useStateValue();
    const history  = useHistory();
    const stripe = useStripe();
    const elements = useElements();

    const [succeeded, setSucceeded] = useState(false);
    const [processing, setProcessing] = useState("");
    const [error, setError] = useState(null);
    const [disabled, setDisebaled] = useState(true);
    const [clientSecret, setClientSecret] = useState(true);

    useEffect(() => {
        //generate the special stripe secret which allows us to charge a customer
        const getClientSecret = async () => {
            const response = await axios ({
                method: 'post',
                // Stripe expects the total in a currencies subunits 
                url: `/payments/create?total=${ getBasketTotal(basket) * 100}`
            });
            setClientSecret(response.data.clientSecret)
        }
        getClientSecret();
    }, [basket] )


    console.log('the secret>>', clientSecret)
    
    const handleSubmit = async (event)  => {
        //do all fancy stripe stuff.....
        event.preventDefault();
        setProcessing(true);

        const patload = await stripe.confirmCardPayment(clientSecret, {
            payment_method:{
                card: elements.getElement(CardElement)
            }
        }).then(({ paymentIntent }) => {

            db
                .collection('users')
                .doc(user?.uid)
                .collection('orders')
                .doc(paymentIntent.id)
                .set({
                    basket: basket,
                    amount: paymentIntent.amount,
                    created: paymentIntent.created
                })

            setSucceeded(true);
            setError(null);
            setProcessing(false);

            dispatch({
                type: 'EMPTY_BASKET'
            })

            history.replace('/orders')
        })

    }

    const handleChange = event => {
        //Listen for changes in the cardelement....
        setDisebaled(event.empty);
        setError(event.error ? error.error.message : "");
    }
    return (
        <div className='payment' >

            <div className='payment__container' >
                <h1>
                    Checkout (
                    <Link to='/checkout' >{basket?.length} items </Link>
                    )
            </h1>

                <div className='payment__section' >
                    <div className='payment__title' >
                        <h3>Delivery address</h3>
                    </div>
                    <div className='payment__address' >
                        <p>{user?.email}</p>
                        <p>123 react Lane</p>
                        <p>Gujrat, Surat</p>
                    </div>
                </div>
                {/*payment section -- review */}
                <div className='payment__section' >
                    <div className='payment__title'>
                        <h3>Review item and delivery</h3>
                    </div>
                    <div className='payment__items' >
                        {basket.map(item => (
                            <CheckoutProduct
                                id={item.id}
                                title={item.title}
                                image={item.image}
                                price={item.price}
                                rating={item.rating}
                            />
                        ))}
                    </div>
                </div>
                {/*payment section -- payment method */}
                <div className='payment__section' >
                    <div className='payment__title' >
                        <h3>Payment type</h3>
                    </div>
                    <div className='payment__details' >
                        <form onSubmit={handleSubmit} >
                            <CardElement onChange={handleChange} />
                            <div className='payment__priceContainer' >
                                <CurrencyFormat
                                    renderText={(value) => (      
                                            <h3>
                                                Order Total: {value}
                                            </h3>
                                    )}
                                    decimalScale={2}
                                    value={getBasketTotal(basket)}
                                    displayType={"text"}
                                    thousandSeparator={true}
                                    prefix={"₹"}
                                />
                                <button disabled={processing || disabled || succeeded} >
                                    <span>{processing? <p>Processing</p> : "Buy Now" }</span>

                                </button>
                            </div>
                            {error && <div>{error}</div>}
                        </form>
                    </div>
                </div>

            </div>
        </div>
    )
}

export default Payment
